import { useState } from "react";

const HomeChefFaq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "How do I verify my kitchen operations?",
      a: "We conduct a virtual audit of your kitchen setup, equipment, hygiene standards, and workflow efficiency to ensure compliance with our elite partner requirements.",
    },
    {
      q: "What is the projected ROI in the first quarter?",
      a: "Most partners see a 3–5x return on investment within 90 days through increased order volume, reduced overhead, and optimized pricing strategies enabled by our growth engine.",
    },
    {
      q: "How does the integrated delivery network function?",
      a: "Our proprietary logistics layer connects you with vetted couriers, real-time tracking, temperature-controlled transport, and dynamic routing — all managed from your dashboard.",
    },
    {
      q: "Can I manage bespoke seasonal tasting menus?",
      a: "Absolutely. Our menu engine supports limited-edition releases, pre-order windows, ingredient sourcing tags, and customer waitlists — perfect for curated culinary experiences.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section style={{ backgroundColor: "#faf9f8" }} className="py-5">
      <div className="container" style={{ maxWidth: "720px" }}>
        {/* Title */}
        <h2 className="text-center mb-5 fw-bold display-6">
          Executive Inquiries
        </h2>

        {/* FAQ List */}
        <div className="d-flex flex-column gap-0">
          {faqs.map((f, i) => (
            <div key={i} className="border-bottom pb-3 pt-3">
              {/* Question Row */}
              <button
                onClick={() => toggleFAQ(i)}
                className="w-100 d-flex justify-content-between align-items-center bg-transparent border-0 p-0 text-start"
                style={{ cursor: "pointer", outline: "none" }}
              >
                <span className="fw-medium text-dark">{f.q}</span>
                <span
                  className={`text-muted transition-transform duration-300 ${
                    openIndex === i ? "rotate-90" : ""
                  }`}
                  style={{
                    transform:
                      openIndex === i ? "rotate(90deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  →
                </span>
              </button>

              {/* Answer (Animated Slide Down) */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i
                    ? "max-height-200 opacity-100 mt-2"
                    : "max-height-0 opacity-0"
                }`}
                style={{
                  maxHeight: openIndex === i ? "200px" : "0",
                  opacity: openIndex === i ? 1 : 0,
                  transition: "all 0.3s ease-out",
                }}
              >
                <p className="text-muted small mb-0">{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeChefFaq;
